import Api from './base';
import methods from './method';
export { LoadConfig } from './config';
Api.use(methods);

export default Api;
